import Vue from 'vue'
import { axGet, axPost } from '../helpers'

/* Vue实例get、post */
const REQUEST = {
  install (Vue) {
    Vue.prototype.axGet = axGet
    Vue.prototype.axPost = axPost
  }
};

Vue.use(REQUEST);
